import Link from 'next/link';

function SizeGuide(props) {
	const {styles} = props;

	return (
		<>
			<div className={`content-wrapper ${styles.oh}`}>
				<div className={styles.pageTitle}>
					<div className={`container ${styles.relative}`}>
						<h1>Size Guide</h1>
						<ol className={styles.breadcrumb}>
							<li>
								<Link href='/'>
									<a>Home</a>
								</Link>
							</li>
							<li className={styles.active}>Size Guide</li>
						</ol>
					</div>
				</div>
				<div className='container'>
					<div className='row'>
						<div className='col-sm-9 mb-50'>
							<h2 className={styles.heading}>Product size guide</h2>
							<p>
								We have provided this item&lsquo;s measurements to help you
								decide which size to buy.
							</p>
							<p>All measurements are in Centimetres & Inches</p>
							<p>
								The following charts will help you match the designer&lsquo;s
								size scheme for this product (indicated in the dropdown) to your
								usual size.
							</p>
							<div className={styles.chart}>
								<h4>Ready to wear size chart</h4>
								<div className='table-responsive' tabIndex='1'>
									<table
										width='100%'
										border='1'
										cellSpacing='5'
										cellPadding='5'
									>
										<tbody>
											<tr>
												<th width='15%' scope='col'>
													&nbsp;
												</th>
												<th width='8%' bgcolor='#DBD8D8' scope='col'>
													<strong>XXS</strong>
												</th>
												<th width='10%' bgcolor='#DBD8D8' scope='col'>
													<strong>XXS - XS</strong>
												</th>
												<th width='8%' bgcolor='#DBD8D8' scope='col'>
													<strong>XS - S</strong>
												</th>
												<th width='7%' bgcolor='#DBD8D8' scope='col'>
													<strong>S - M</strong>
												</th>
												<th width='7%' bgcolor='#DBD8D8' scope='col'>
													<strong>M - L</strong>
												</th>
												<th width='8%' bgcolor='#DBD8D8' scope='col'>
													<strong>L - XL</strong>
												</th>
												<th width='12%' bgcolor='#DBD8D8' scope='col'>
													<strong>XL - XXL</strong>
												</th>
												<th width='14%' bgcolor='#DBD8D8' scope='col'>
													<strong>XXL - XXXL</strong>
												</th>
												<th width='11%' bgcolor='#DBD8D8' scope='col'>
													<strong>XXXL</strong>
												</th>
											</tr>
											<tr>
												<th height='40' align='center' valign='middle'>
													<p>
														<strong>Australia</strong>
														<strong>
															<br />
														</strong>
													</p>
												</th>
												<th align='center' valign='middle'>
													4
												</th>
												<th align='center' valign='middle'>
													6
												</th>
												<th align='center' valign='middle'>
													8
												</th>
												<th align='center' valign='middle'>
													10
												</th>
												<th align='center' valign='middle'>
													12
												</th>
												<th align='center' valign='middle'>
													14
												</th>
												<th align='center' valign='middle'>
													16
												</th>
												<th align='center' valign='middle'>
													18
												</th>
												<th align='center' valign='middle'>
													20
												</th>
											</tr>
											<tr>
												<th height='40' align='center' valign='middle'>
													<p>
														<strong>US</strong>
													</p>
												</th>
												<th align='center' valign='middle'>
													00
												</th>
												<th align='center' valign='middle'>
													0
												</th>
												<th align='center' valign='middle'>
													2 - 4
												</th>
												<th align='center' valign='middle'>
													4 - 6
												</th>
												<th align='center' valign='middle'>
													8
												</th>
												<th align='center' valign='middle'>
													10
												</th>
												<th align='center' valign='middle'>
													12
												</th>
												<th align='center' valign='middle'>
													14
												</th>
												<th align='center' valign='middle'>
													16
												</th>
											</tr>
											<tr>
												<th height='40' align='center' valign='middle'>
													<strong>UK</strong>
												</th>
												<th align='center' valign='middle'>
													4
												</th>
												<th align='center' valign='middle'>
													6
												</th>
												<th align='center' valign='middle'>
													8
												</th>
												<th align='center' valign='middle'>
													10
												</th>
												<th align='center' valign='middle'>
													12
												</th>
												<th align='center' valign='middle'>
													14
												</th>
												<th align='center' valign='middle'>
													16
												</th>
												<th align='center' valign='middle'>
													18
												</th>
												<th align='center' valign='middle'>
													20
												</th>
											</tr>
											<tr>
												<th height='40' align='center' valign='middle'>
													<strong>Italy</strong>
												</th>
												<th align='center' valign='middle'>
													36
												</th>
												<th align='center' valign='middle'>
													38
												</th>
												<th align='center' valign='middle'>
													40
												</th>
												<th align='center' valign='middle'>
													42
												</th>
												<th align='center' valign='middle'>
													44
												</th>
												<th align='center' valign='middle'>
													46
												</th>
												<th align='center' valign='middle'>
													48
												</th>
												<th align='center' valign='middle'>
													50
												</th>
												<th align='center' valign='middle'>
													52
												</th>
											</tr>
											<tr>
												<th height='40' align='center' valign='middle'>
													<strong>Denmark</strong>
												</th>
												<th align='center' valign='middle'>
													30
												</th>
												<th align='center' valign='middle'>
													32
												</th>
												<th align='center' valign='middle'>
													34
												</th>
												<th align='center' valign='middle'>
													36
												</th>
												<th align='center' valign='middle'>
													38
												</th>
												<th align='center' valign='middle'>
													40
												</th>
												<th align='center' valign='middle'>
													42
												</th>
												<th align='center' valign='middle'>
													44
												</th>
												<th align='center' valign='middle'>
													46
												</th>
											</tr>
											<tr>
												<th height='40' align='center' valign='middle'>
													<strong>Russia</strong>
												</th>
												<th align='center' valign='middle'>
													38
												</th>
												<th align='center' valign='middle'>
													40
												</th>
												<th align='center' valign='middle'>
													42
												</th>
												<th align='center' valign='middle'>
													44
												</th>
												<th align='center' valign='middle'>
													46
												</th>
												<th align='center' valign='middle'>
													48
												</th>
												<th align='center' valign='middle'>
													50
												</th>
												<th align='center' valign='middle'>
													52
												</th>
												<th align='center' valign='middle'>
													54
												</th>
											</tr>
											<tr>
												<th height='40' align='center' valign='middle'>
													<strong>Germany</strong>
												</th>
												<th align='center' valign='middle'>
													30
												</th>
												<th align='center' valign='middle'>
													32
												</th>
												<th align='center' valign='middle'>
													34
												</th>
												<th align='center' valign='middle'>
													36
												</th>
												<th align='center' valign='middle'>
													38
												</th>
												<th align='center' valign='middle'>
													40
												</th>
												<th align='center' valign='middle'>
													42
												</th>
												<th align='center' valign='middle'>
													44
												</th>
												<th align='center' valign='middle'>
													46
												</th>
											</tr>
											<tr>
												<th height='40' align='center' valign='middle'>
													<strong>Japan</strong>
												</th>
												<th align='center' valign='middle'>
													3
												</th>
												<th align='center' valign='middle'>
													5
												</th>
												<th align='center' valign='middle'>
													7
												</th>
												<th align='center' valign='middle'>
													9
												</th>
												<th align='center' valign='middle'>
													11
												</th>
												<th align='center' valign='middle'>
													13
												</th>
												<th align='center' valign='middle'>
													15
												</th>
												<th align='center' valign='middle'>
													17
												</th>
												<th align='center' valign='middle'>
													19
												</th>
											</tr>
											<tr>
												<th height='40' align='center' valign='middle'>
													<strong>
														Jeans
														<br />
													</strong>
												</th>
												<th align='center' valign='middle'>
													23
												</th>
												<th align='center' valign='middle'>
													24 - 25
												</th>
												<th align='center' valign='middle'>
													26 - 27
												</th>
												<th align='center' valign='middle'>
													27 - 28
												</th>
												<th align='center' valign='middle'>
													28 - 29
												</th>
												<th align='center' valign='middle'>
													29 - 30
												</th>
												<th align='center' valign='middle'>
													30 - 31
												</th>
												<th align='center' valign='middle'>
													32 - 33
												</th>
												<th align='center' valign='middle'>
													&nbsp;
												</th>
											</tr>
										</tbody>
									</table>
								</div>
								<h4>&nbsp;</h4>
								<h4>Shoe Size Chart</h4>
								<div className='table-responsive' tabIndex='1'>
									<table
										width='100%'
										border='1'
										cellSpacing='5'
										cellPadding='5'
									>
										<tbody>
											<tr>
												<th width='14%' height='40'>
													<p>
														<strong>US</strong>
													</p>
												</th>
												<th>4</th>
												<th>4.5</th>
												<th>5</th>
												<th>5.5</th>
												<th>6</th>
												<th>6.5</th>
												<th>7</th>
												<th>7.5</th>
												<th>8</th>
												<th>8.5</th>
												<th>9</th>
												<th>9.5</th>
												<th>10</th>
												<th>10.5</th>
												<th>11</th>
												<th>11.5</th>
												<th>12</th>
											</tr>
											<tr>
												<th height='40'>
													<strong>
														UK
														<br />
													</strong>
												</th>
												<th>1</th>
												<th>1.5</th>
												<th>2</th>
												<th>2.5</th>
												<th>3</th>
												<th>3.5</th>
												<th>4</th>
												<th>4.5</th>
												<th>5</th>
												<th>5.5</th>
												<th>6</th>
												<th>6.5</th>
												<th>7</th>
												<th>7.5</th>
												<th>8</th>
												<th>8.5</th>
												<th>9</th>
											</tr>
											<tr>
												<th height='40'>
													<p>
														<strong>Italy/Europe</strong>
													</p>
												</th>
												<th>34</th>
												<th>34.5</th>
												<th>35</th>
												<th>35.5</th>
												<th>36</th>
												<th>36.5</th>
												<th>37</th>
												<th>37.5</th>
												<th>38</th>
												<th>38.5</th>
												<th>39</th>
												<th>39.5</th>
												<th>40</th>
												<th>40.5</th>
												<th>41</th>
												<th>41.5</th>
												<th>42</th>
											</tr>
											<tr>
												<th height='40'>
													<p>
														<strong>France</strong>
													</p>
												</th>
												<th>35</th>
												<th>35.5</th>
												<th>36</th>
												<th>36.5</th>
												<th>37</th>
												<th>37.5</th>
												<th>38</th>
												<th>38.5</th>
												<th>39</th>
												<th>39.5</th>
												<th>40</th>
												<th>40.5</th>
												<th>41</th>
												<th>41.5</th>
												<th>42</th>
												<th>42.5</th>
												<th>43</th>
											</tr>
										</tbody>
									</table>
								</div>

								<br />
								<p className={styles.note}>
									<em>
										Please note, this is an approximate size conversion guide.
										Conversions may vary from brand to brand. For further
										information or advice, contact customer care.
									</em>
								</p>
								<h4>&nbsp;</h4>
								<h4>Kidswear Shoe Size Chart</h4>
								<div className='table-responsive' tabIndex='1'>
									<table
										width='100%'
										border='1'
										cellSpacing='5'
										cellPadding='5'
									>
										<tbody>
											<tr>
												<th height='40' align='center' valign='middle'>
													<p>
														<strong>Approx. age</strong>
													</p>
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													3-6m
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													6-9m
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													9-12m
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													12-18m
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													18-12m
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													2 yr
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													3 yr
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													4 yr
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													5 yr
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													6 yr
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													7 yr
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													8 yr
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													9 yr
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													10 yr
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													11 yr
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													12 yr
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													13 yr
												</th>
												<th align='center' valign='middle' bgcolor='#DBD8D8'>
													14 yr
												</th>
											</tr>
											<tr>
												<th
													width='14%'
													height='40'
													align='center'
													valign='middle'
												>
													<p>
														<strong>UK</strong>
													</p>
												</th>
												<th align='center' valign='middle'>
													2
												</th>
												<th align='center' valign='middle'>
													3
												</th>
												<th align='center' valign='middle'>
													4
												</th>
												<th align='center' valign='middle'>
													5
												</th>
												<th align='center' valign='middle'>
													6
												</th>
												<th align='center' valign='middle'>
													7
												</th>
												<th align='center' valign='middle'>
													8
												</th>
												<th align='center' valign='middle'>
													9
												</th>
												<th align='center' valign='middle'>
													10
												</th>
												<th align='center' valign='middle'>
													11
												</th>
												<th align='center' valign='middle'>
													12
												</th>
												<th align='center' valign='middle'>
													13
												</th>
												<th align='center' valign='middle'>
													1
												</th>
												<th align='center' valign='middle'>
													2
												</th>
												<th align='center' valign='middle'>
													2.5
												</th>
												<th align='center' valign='middle'>
													3
												</th>
												<th align='center' valign='middle'>
													4
												</th>
												<th align='center' valign='middle'>
													5
												</th>
											</tr>
											<tr>
												<th height='40' align='center' valign='middle'>
													<p>
														<strong>Italy/Europe</strong>
													</p>
												</th>
												<th align='center' valign='middle'>
													17.5
												</th>
												<th align='center' valign='middle'>
													18.5
												</th>
												<th align='center' valign='middle'>
													20
												</th>
												<th align='center' valign='middle'>
													21
												</th>
												<th align='center' valign='middle'>
													22.5
												</th>
												<th align='center' valign='middle'>
													24
												</th>
												<th align='center' valign='middle'>
													26.5
												</th>
												<th align='center' valign='middle'>
													27
												</th>
												<th align='center' valign='middle'>
													28
												</th>
												<th align='center' valign='middle'>
													29
												</th>
												<th align='center' valign='middle'>
													30
												</th>
												<th align='center' valign='middle'>
													32
												</th>
												<th align='center' valign='middle'>
													33
												</th>
												<th align='center' valign='middle'>
													34
												</th>
												<th align='center' valign='middle'>
													35
												</th>
												<th align='center' valign='middle'>
													36
												</th>
												<th align='center' valign='middle'>
													37
												</th>
												<th align='center' valign='middle'>
													38
												</th>
											</tr>
										</tbody>
									</table>
								</div>

								<h4>&nbsp;</h4>
								<h4>Ring size chart</h4>
								<div className='table-responsive' tabIndex='1'>
									<table
										width='100%'
										border='1'
										cellSpacing='5'
										cellPadding='5'
									>
										<tbody>
											<tr className='alt'>
												<th className='country'>
													<strong>US</strong>
												</th>
												<th>4 </th>
												<th>4¼</th>
												<th>4½</th>
												<th>4¾ </th>
												<th>5</th>
												<th>5¼ </th>
												<th>5½ </th>
												<th>5¾</th>
												<th>6</th>
												<th>6¼ </th>
												<th>6½ </th>
												<th>6¾ </th>
												<th>7</th>
												<th>7¼ </th>
												<th>7½ </th>
												<th>7¾</th>
												<th>8</th>
												<th>8¼ </th>
												<th>8½</th>
												<th>8¾</th>
												<th>9</th>
											</tr>
											<tr>
												<th className='country'>
													<strong>UK</strong>
												</th>
												<th>H½ </th>
												<th>I</th>
												<th>I½ </th>
												<th>J</th>
												<th>J½ </th>
												<th>K</th>
												<th>K½ </th>
												<th>L</th>
												<th>L½ </th>
												<th>M </th>
												<th>M½ </th>
												<th>N </th>
												<th>N½ </th>
												<th>O </th>
												<th>O½ </th>
												<th>P </th>
												<th>P½ </th>
												<th>Q </th>
												<th>Q½</th>
												<th>R</th>
												<th>R½</th>
											</tr>
											<tr className='alt'>
												<th className='country'>
													<strong>Italy</strong>
												</th>
												<th>8</th>
												<th>8/9</th>
												<th>9</th>
												<th>10</th>
												<th>10/11</th>
												<th>11</th>
												<th>12</th>
												<th>12/13</th>
												<th>13 </th>
												<th>14</th>
												<th>14/15</th>
												<th>15</th>
												<th>15/16</th>
												<th>16</th>
												<th>17</th>
												<th>17/18</th>
												<th>18</th>
												<th>18/19</th>
												<th>19</th>
												<th>19/20</th>
												<th>20</th>
											</tr>
											<tr>
												<th className='country'>
													<strong>France</strong>
												</th>
												<th>46</th>
												<th>47</th>
												<th>48</th>
												<th>49</th>
												<th>49.5</th>
												<th>50</th>
												<th>50.5</th>
												<th>51</th>
												<th>52</th>
												<th>53</th>
												<th>53.5</th>
												<th>54</th>
												<th>54.5</th>
												<th>55</th>
												<th>55.5</th>
												<th>56</th>
												<th>57</th>
												<th>58</th>
												<th>58.5</th>
												<th>59</th>
												<th>60</th>
											</tr>
										</tbody>
									</table>
								</div>

								<h4>&nbsp;</h4>
								<h4>Glove size chart</h4>
								<div className='table-responsive' tabIndex='1'>
									<table
										width='100%'
										border='1'
										cellPadding='5'
										cellSpacing='5'
									>
										<tbody>
											<tr className='alt'>
												<th className='country'>
													<strong>Ladies</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>XS</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>S</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>M</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>L</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>XL</strong>
												</th>
											</tr>
											<tr>
												<th className='country'>Size &quot;</th>
												<th>6</th>
												<th>6.5</th>
												<th>7/7.5</th>
												<th>8</th>
												<th>8.5/9</th>
											</tr>
										</tbody>
									</table>
								</div>

								<h4>&nbsp;</h4>
								<h4>Belt size chart</h4>
								<div className='table-responsive' tabIndex='1'>
									<table
										width='100%'
										border='1'
										cellPadding='5'
										cellSpacing='5'
									>
										<tbody>
											<tr className='alt'>
												<th>
													<strong>US</strong>
												</th>
												<th>00</th>
												<th>0</th>
												<th>2 - 4</th>
												<th>4 - 6</th>
												<th>8</th>
												<th>10</th>
												<th>12</th>
												<th>14</th>
												<th>16</th>
											</tr>
											<tr>
												<th className='country'>
													<strong>UK</strong>
												</th>
												<th>4</th>
												<th>6</th>
												<th>8</th>
												<th>10</th>
												<th>12</th>
												<th>14</th>
												<th>16</th>
												<th>18</th>
												<th>20</th>
											</tr>
											<tr className='alt'>
												<th className='country'>
													<strong>Italy</strong>
												</th>
												<th>36</th>
												<th>38</th>
												<th>40</th>
												<th>42</th>
												<th>44</th>
												<th>46</th>
												<th>48</th>
												<th>50</th>
												<th>52</th>
											</tr>
											<tr>
												<th className='country'>
													<strong>Europe</strong>
												</th>
												<th>65</th>
												<th>70</th>
												<th>75</th>
												<th>80</th>
												<th>85</th>
												<th>90</th>
												<th>95</th>
												<th>100</th>
												<th>105</th>
											</tr>

											<tr className='alt'>
												<th></th>
												<th bgcolor='#DBD8D8'>
													<strong>XXS</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>XXS - XS</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>XS - S</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>S - M</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>M - L</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>L - XL</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>XL - XXL</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>XXL - XXXL</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>XXXL</strong>
												</th>
											</tr>
										</tbody>
									</table>
								</div>

								<h4>&nbsp;</h4>
								<h4>Hat size chart</h4>
								<div className='table-responsive' tabIndex='1'>
									<table
										width='100%'
										border='1'
										cellPadding='5'
										cellSpacing='5'
									>
										<tbody>
											<tr className='alt'>
												<th className='country'>
													<strong>US</strong>
												</th>
												<th>6½</th>
												<th>6⅝</th>
												<th>6¾</th>
												<th>6⅞</th>
												<th>7</th>
												<th>7⅛</th>
												<th>7¼</th>
												<th>7⅜</th>
												<th>7½</th>
												<th>7⅝</th>
											</tr>
											<tr>
												<th className='country'>
													<strong>UK</strong>
												</th>
												<th>6⅜</th>
												<th>6½</th>
												<th>6⅝</th>
												<th>6¾</th>
												<th>6⅞</th>
												<th>7</th>
												<th>7⅛</th>
												<th>7¼</th>
												<th>7⅜</th>
												<th>7½</th>
											</tr>
											<tr className='alt'>
												<th className='country'>
													<strong>Europe</strong>
												</th>
												<th>52</th>
												<th>53</th>
												<th>54</th>
												<th>55</th>
												<th>56</th>
												<th>57</th>
												<th>58</th>
												<th>59</th>
												<th>60</th>
												<th>61</th>
											</tr>

											<tr className='alt'>
												<th>&nbsp;</th>
												<th bgcolor='#DBD8D8'>
													<strong>XS</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>XS</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>S</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>S</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>M</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>M</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>L</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>L</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>XL</strong>
												</th>
												<th bgcolor='#DBD8D8'>
													<strong>XL</strong>
												</th>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default SizeGuide;
